import { Component, Inject, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { asShortLink, editionPrefix } from 'src/app/app.component';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {
  copyTextToClipboard,
  getPinWithEdition,
} from 'src/app/utility/app.utils';
import { UtilityService } from '../utility/utility.service';
import { MatIcon } from '@angular/material/icon';

import {
  EmbedDialogComponent,
  EmbedDialogData,
} from '../cms/panel/embed-dialog.component';
import { MatTooltip } from '@angular/material/tooltip';
import { QrCodePreviewComponent } from './qr-code-preview/qr-code-preview.component';
export interface QrData {
  qr: SafeHtml;
  pin: string;
  edition?: string;
  qrDataUrl: string;
  openInNewTabText?: string;
  generatingFlyer?: boolean;
  canDownLoadFlyer?: boolean;
  embedDialogData?: EmbedDialogData;
  invitationLink?: {
    click: () => void;
  };
  generateFlyer?: {
    click: () => void;
  };
}

@Component({
  selector: 'qr-model',
  templateUrl: './qr-model.component.html',
  styleUrls: ['./qr-model.component.scss'],
  imports: [MatIcon, TranslateModule, MatTooltip, QrCodePreviewComponent],
})
export class QrModalComponent implements OnInit {
  qrData: QrData;
  shortLinkPrefix = asShortLink('', false);
  asShortLink = asShortLink;
  editionPrefix = editionPrefix();

  constructor(
    private utilityService: UtilityService,
    private translator: TranslateService,
    private matSnackBar: MatSnackBar,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<QrModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: QrData
  ) {
    this.dialogRef.addPanelClass('qr-overlay-component-panel');
  }

  ngOnInit(): void {
    this.qrData = this.data;
    if (this.data.edition) {
      this.editionPrefix = this.data.edition;
    }
  }

  close() {
    this.dialogRef.close();
  }

  copyWeblink() {
    try {
      copyTextToClipboard(asShortLink(this.qrData.pin));
      this.matSnackBar.open(
        this.translator.instant('exam.message.copiedToClipboard')
      );
    } catch (error) {
      this.matSnackBar.open(
        this.translator.instant('exam.message.notCopiedToClipboard')
      );
    }
  }
  onInvitationMailUrlClick() {
    if (this.qrData.invitationLink) {
      this.qrData.invitationLink.click();
    }
  }

  onGenerateFlyerClick() {
    if (this.qrData.generateFlyer) {
      this.qrData.generateFlyer.click();
    }
  }

  copyPin() {
    this.utilityService.copyPin(getPinWithEdition(this.qrData?.pin));
  }

  embedCourse() {
    this.matDialog.open<unknown, EmbedDialogData>(EmbedDialogComponent, {
      data: this.qrData?.embedDialogData as EmbedDialogData,
      autoFocus: false,
    });
  }
}
